import { render, staticRenderFns } from "./business-card-form-type.vue?vue&type=template&id=2ae98c18&scoped=true&"
import script from "./business-card-form-type.vue?vue&type=script&lang=js&"
export * from "./business-card-form-type.vue?vue&type=script&lang=js&"
import style0 from "./business-card-form-type.vue?vue&type=style&index=0&id=2ae98c18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae98c18",
  null
  
)

export default component.exports